import { init } from '@emailjs/browser';

export const initEmailJS = () => {
  init('uhpZ76p8L_vOFpGlF'); 
};

// EmailJS configuration - replace these values with your actual IDs
export const EMAILJS_SERVICE_ID = 'service_9ngucfd';
export const EMAILJS_TEMPLATE_ID = 'template_mzor9iq';
export const EMAILJS_PUBLIC_KEY = 'uhpZ76p8L_vOFpGlF'; 